export default __webpack_public_path__ + "static/media/notification-button-arrow-white.c56da900.svg";